import * as config from '#frontend/config'
import { main } from './frontend.gleam'

// Setup the environment.
config.elements.register()
config.vercel.setup()

// Setup Service Worker.
const serviceWorker = config.serviceWorker.setup()

// Wait for frontend to be ready to load.
const ready = new Promise(resolve => {
  document.addEventListener('DOMContentLoaded', resolve, { once: true })
})

// Wait for service worker and frontend to be ready.
Promise.all([serviceWorker, ready]).then(() => main())
